import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'

import { rebootApi } from '../../infrastructure/rebootApi'

/**
 * Beam does not observe the node coming back, and a patch is only marked active
 * on the node's first boot — so nothing on the patch list changes after a
 * reboot, and there is nothing to invalidate here.
 */
export const useRebootNode = () =>
  useMutation({
    mutationFn: (nodeId: string) => rebootApi.requestReboot(nodeId),
    onSuccess: () => {
      toast.success(
        'Reboot requested. The node boots into the config that is already on its disk.',
      )
    },
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
